import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import {
	asyncScheduler,
	AsyncSubject,
	Subscription,
	takeUntil,
	timer,
} from 'rxjs';
import {
	PerformanceTrackingInterceptorEvent,
	performanceTrackingInterceptorStore,
} from 'src/lib/configuration/performance-tracking.interceptor';
import { InitializationService } from '../../utility/initialization/initialization.service';

@Injectable({
	providedIn: 'root',
})
export class PerformanceTrackingReporterService implements OnDestroy {
	private _unsubscribe$ = new AsyncSubject<null>();

	private subscription: Subscription;

	constructor(
		private httpClient: HttpClient,
		private initializationService: InitializationService,
	) {}

	public init = () => {
		if (this.subscription) {
			return;
		}

		if (!this.initializationService.enable_performance_tracking) {
			return;
		}

		this.subscription = timer(5000, 5000, asyncScheduler)
			.pipe(takeUntil(this._unsubscribe$))
			.subscribe(() => {
				const events = performanceTrackingInterceptorStore.events;
				performanceTrackingInterceptorStore.events = [];

				if (events.length > 0) {
					this.sendEvents(events);
				}
			});
	};

	private sendEvents = (events: PerformanceTrackingInterceptorEvent[]) => {
		this.httpClient
			.post<null>(`/api/v1/log-store/performance-tracking`, {
				message: `Recorded ${events.length} performance tracking events`,
				log: events,
			})
			.subscribe();
	};

	ngOnDestroy() {
		this._unsubscribe$.next(null);
		this._unsubscribe$.complete();
		this._unsubscribe$ = null;
	}
}
